import {takeEvery} from 'redux-saga/effects'
import {
  ADD_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDERS_IN_BULK,
  DELETE_PURCHASE_ORDER_BY_ID,
  GET_PDF_PURCHASE_ORDER_REPORT,
  GET_PURCHASE_ORDER,
  GET_PURCHASE_ORDERS,
  UPDATE_PURCHASE_ORDER,
} from 'setup/redux/Actions/PurchaseOrder/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_PURCHASE_ORDERS, fetchData)
  yield takeEvery(GET_PURCHASE_ORDER, fetchData)
  yield takeEvery(ADD_PURCHASE_ORDER, fetchData)
  yield takeEvery(UPDATE_PURCHASE_ORDER, fetchData)
  yield takeEvery(DELETE_PURCHASE_ORDERS_IN_BULK, fetchData)
  yield takeEvery(DELETE_PURCHASE_ORDER_BY_ID, fetchData)
  yield takeEvery(GET_PDF_PURCHASE_ORDER_REPORT, fetchData)
}

export default dataSaga
